import React from 'react';
import { Button } from './ui/button';

type ViewMode = 'game' | 'audit' | 'prompt';

interface Props {
  activeView: ViewMode;
  onChangeView: (view: ViewMode) => void;
  theme: 'light' | 'dark';
  onToggleTheme: () => void;
  statMode: boolean;
  onToggleStatMode: () => void;
  hintMode: boolean;
  onToggleHintMode: () => void;
}

export const TopBar: React.FC<Props> = ({
  activeView,
  onChangeView,
  theme,
  onToggleTheme,
  statMode,
  onToggleStatMode,
  hintMode,
  onToggleHintMode,
}) => {
  return (
    <header className="sticky top-0 z-30 border-b border-border bg-card/80 backdrop-blur">
      <div className="mx-auto flex h-14 w-full max-w-5xl items-center justify-between gap-4 px-4">
        <div className="flex items-center gap-2">
          <Button
            variant={activeView === 'game' ? 'secondary' : 'ghost'}
            size="sm"
            onClick={() => onChangeView('game')}
          >
            Game
          </Button>
          <Button
            variant={activeView === 'audit' ? 'secondary' : 'ghost'}
            size="sm"
            onClick={() => onChangeView('audit')}
          >
            Audit & Export
          </Button>
          <Button
            variant={activeView === 'prompt' ? 'secondary' : 'ghost'}
            size="sm"
            onClick={() => onChangeView('prompt')}
          >
            LLM Prompt
          </Button>
        </div>
        <div className="flex items-center gap-2">
          <Button
            variant={statMode ? 'secondary' : 'outline'}
            size="sm"
            onClick={onToggleStatMode}
            aria-pressed={statMode}
          >
            Stat Mode: {statMode ? 'On' : 'Off'}
          </Button>
          <Button
            variant={hintMode ? 'secondary' : 'outline'}
            size="sm"
            onClick={onToggleHintMode}
            aria-pressed={hintMode}
          >
            Hint Mode: {hintMode ? 'On' : 'Off'}
          </Button>
          <Button variant="outline" size="sm" onClick={onToggleTheme}>
            Theme: {theme === 'light' ? 'Light' : 'Dark'}
          </Button>
        </div>
      </div>
    </header>
  );
};
